"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArray = void 0;
function isArray(arr) {
    return Array.isArray(arr);
}
exports.isArray = isArray;
//# sourceMappingURL=index.js.map